import { Layout, Button, Card, Checkbox, Input, Table} from 'element-react';
import { useTranslation } from 'react-i18next';
import { S3Image } from "../components/S3Image";
import { useHistory } from "react-router-dom";
import {yearsFromToday, yearFromDate} from '../utils/FormatUtils';
import aboutUsImg from '../assets/imgs/about-us-default.png';
import companyImg from '../assets/imgs/my-company-default2.png';
import ProductBox from '../components/ProductBox';
import {IoIosChatbubbles} from "react-icons/io";
import {countryOptions} from '../utils/Catalogs';
// Import Swiper React components
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

import PlaceholderProductBox from '../components/PlaceholderProductBox';
import AddProductCard from '../components/AddProductCard';

import VerifiedBadge from '../components/VerifiedBadge';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);


const MyPage = (props) =>{
    const history = useHistory();
    const { t } = useTranslation();
    const toAddProduct = () =>{
        if (props.toAddProduct) {
            props.toAddProduct();
        } else {
            history.push('/add-product-wizard/0');
        }
    }
    const themeConfig = {
        //photoImg: { maxWidth: "75Vw", maxHeight: "40vh", minHeight: "40vh" }
        photoImg: {
            display: 'block',
            width: "100%",
        }
    }

    // ==============================================================
    // === SIMULACIÓN PLAN =======================================
    // ==============================================================
    
    // CAMBIA ESTO A 'Premium' o 'Enterprise' PARA VER EL CARRUSEL
    const SIMULATED_PLAN = 'Premium'; 
    
    // Lógica basada en la simulación
    const isFreePlan = SIMULATED_PLAN === 'Free';

    // ==============================================================

    // --- Definición de columnas para la tabla (Solo plan Free) ---
    const tableColumns = [
        {
            label: "Product",
            prop: "name", 
            //minWidth: 200
            flex: 1
        },
        {
            label: "Category",
            prop: "category", 
            //minWidth: 150,
            render: (data) => {
                // CASO 1: Si category es un OBJETO (viene de featuresProduct / BD)
                if (data.category && typeof data.category === 'object') {
                    return data.category.name || "General";
                }
                
                // CASO 2: Si category es un TEXTO (viene de nuestra lógica promote)
                if (typeof data.category === 'string') {
                    return data.category;
                }

                // CASO 3: Fallback
                return "General"; 
            }
        }
    ];

    let displayCategory = "General";
    if (props.companyPage && props.companyPage.featured_category) {
        const cat = props.companyPage.featured_category;
        if (typeof cat === 'string') {
             const parts = cat.split('|'); 
             displayCategory = parts[parts.length - 1].trim();
        } else if (Array.isArray(cat)) {
             displayCategory = cat.join(" / ");
        }
    }

    const promoteProducts = [];
    if (props.companyPage) {
        if (props.companyPage.promote1) promoteProducts.push({ name: props.companyPage.promote1, category: displayCategory });
        if (props.companyPage.promote2) promoteProducts.push({ name: props.companyPage.promote2, category: displayCategory });
        if (props.companyPage.promote3) promoteProducts.push({ name: props.companyPage.promote3, category: displayCategory });
        if (props.companyPage.promote4) promoteProducts.push({ name: props.companyPage.promote3, category: displayCategory });
    }

    const tableData = promoteProducts.length > 0 ? promoteProducts : (props.featuresProduct || []);

    const handleUpdateProfile = () => {
        if (props.companyPage && props.companyPage.id) {
            // Redirige al Wizard, paso 1 (donde están los productos promoted)
            history.push(`/my-store-wizard-ng/${props.companyPage.id}/1`);
        }
    }

    // Lógica para obtener la ubicación formateada 
    const getFormattedLocation = () => {
        const addr = props.companyPage.address;
        if (!addr) return props.companyPage.region || ""; 

        const parts = [];
        if (addr.state) parts.push(addr.state);
        if (addr.country) parts.push(addr.country);
        
        // Si no hay estado ni país, intentar con ciudad
        if (parts.length === 0 && addr.city) return addr.city;

        return parts.join(", ");
    };

    // Lógica para obtener la ciudad 
    const getCityLocation = () => {
        const addr = props.companyPage.address;
        if (addr && addr.city) return addr.city;
        return props.companyPage.region || ""; // Fallback
    }

    const displayLocation = getFormattedLocation();
    const displayCity = getCityLocation();

    return(
        <div className='Company-store-page'>
            <Layout.Row gutter="20" className="espaciador-movil">
                <Layout.Col offset="1" span="20">
                    &nbsp;
                </Layout.Col>
            </Layout.Row>
            <Layout.Row gutter="22">
                <Layout.Col xs={{ span: 23, offset: 0 }} md={{ span: 22, offset: 1 }}>
                        <div className="card-mypage">
                                <Layout.Row type="flex" justify="center">
                                    <Layout.Col md="18" sm="24" xs="24">
                                        <div className="card-container" style={{ maxWidth: "100%"}}>
                                            {
                                                props.companyPage.cover_picture
                                                ?
                                                    <S3Image
                                                    imgKey={props.companyPage.cover_picture.key}
                                                    theme={themeConfig}
                                                    level="public"
                                                    className="Mypage-ImageCompany"
                                                    />
                                                :
                                                    
                                                    <img alt='Company cover fallback' src={companyImg} style={{ maxWidth: "100%"}}/> 
                                            }
                                            
                                            <div className="company-title">
                                                {props.companyPage.name}
                                            </div>
                                            {props.owner === true 
                                                ?
                                                    <div className="company-title-img-btn">
                                                            <div className="text-center">
                                                                <Button type="primary" onClick={()=> props.editCompanyImage('cover_picture')}>
                                                                    {t('my-store.page.button-change-img')}
                                                                </Button>
                                                            </div>
                                                    </div>
                                                :
                                                    <></>
                                            }
                                        </div>
                                        
                                    </Layout.Col>
                                    <Layout.Col md="6" sm="24" xs="24">
                                            <Layout.Row type="flex">
                                                <Layout.Col>
                                                    <h3>{t('my-store.page.type-title')}</h3>        
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex">
                                                <Layout.Col tag="cardPageText">
                                                    {t('my-store.page.name')} :
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex">
                                                <Layout.Col tag="cardPageTextSub">
                                                    {/* Contenedor flex en columna para forzar que los elementos bajen de línea */}
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                                        
                                                        {/* 1. Nombre de la Empresa */}
                                                        <b style={{ marginBottom: '4px' }}>{props.companyPage.name}</b>
                                                        
                                                        {/* 2. Insignia de Verificado — el componente consulta el estado directamente */}
                                                        <VerifiedBadge
                                                            companyId={props.companyPage.id}
                                                            isVerified={props.companyPage.is_verified || props.companyPage.isVerified || props.companyPage.verified}
                                                            style={{ marginLeft: '0px' }}
                                                        />

                                                        {/* 3. Rating (Se queda preparado para cuando te lo pidan) */}
                                                        { props.companyPage.supplier_rating ? (
                                                            <span className="result-supplier-rating" style={{ marginTop: '4px' }}>
                                                                {props.companyPage.supplier_rating} 
                                                            </span>
                                                        ) : null }

                                                    </div>
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex">
                                                <Layout.Col tag="cardPageText">
                                                    {t('my-store.page.type')} :
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex">
                                                <Layout.Col tag="cardPageTextSub">
                                                <b>{props.companyPage.type}</b>
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex">
                                                <Layout.Col tag="cardPageText">
                                                    {t('my-store.page.member-since')} :
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex">
                                                <Layout.Col tag="cardPageTextSub">
                                                <b>{props.companyPage ? yearFromDate(props.companyPage.createdAt): ""}</b>
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex">
                                                <Layout.Col tag="cardPageText">
                                                    {t('my-store.page.location')} :
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex">
                                                <Layout.Col tag="cardPageTextSub">
                                                <b>
                                                    {displayLocation}
                                                </b>
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex">
                                                <Layout.Col>
                                                    &nbsp;
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex" justify="center">
                                                <Layout.Col tag="form-button">
                                                    <div className="text-center my-page-chat-btn">
                                                        <Button type="primary" onClick={props.handleChatWithUs}>
                                                            <IoIosChatbubbles className="p-r-xxs"/>{t('my-store.page.button-contact')}
                                                        </Button>
                                                    </div>
                                                </Layout.Col>
                                            </Layout.Row>
                                    </Layout.Col>
                                </Layout.Row>
                        </div>               
                    </Layout.Col>
                </Layout.Row>
                <Layout.Row gutter="20" className="espaciador-movil">
                    <Layout.Col offset="1" span="20">
                        &nbsp;
                    </Layout.Col>
                </Layout.Row>
                
                <Layout.Row gutter="22">
                    <Layout.Col offset="1" span="22" xs={{ span: 24, offset: 0 }}>
                        <Card className="box-card"
                            header={
                                <h3>
                                    {isFreePlan ? "Products" : t('my-store.page.featured-products')}
                                </h3>
                            }
                        >

                            <Layout.Row gutter="22" className="m-t-md">
                                <Layout.Col span="24">
                                    <div className="demo-3 medium carrucel-AddProducts">

                                {/* CARRUSEL (Solo se muestra si NO es Free)                 */}
                                {!isFreePlan && (
                                    <div className="premium-carousel-section" style={{ marginBottom: '40px' }}>
                                        {props.featuresProduct && props.featuresProduct.length > 0 ? (
                                            <Swiper 
                                                slidesPerView={4} spaceBetween={10} slidesPerGroup={1} 
                                                loop={true}
                                                pagination={{"clickable": true, "bulletActiveClass": 'dots-pagination'}} 
                                                navigation={true}
                                                className="mySwiper"
                                                centeredSlides={true}
                                                centeredSlidesBounds={true}
                                                preventClicks={true}
                                                breakpoints={{
                                                    344: { slidesPerView: 1, },
                                                    640: { slidesPerView: 1, },
                                                    768: { slidesPerView: 2, },
                                                    1024: { slidesPerView: 4, }
                                                }}
                                            >
                                                {props.featuresProduct.map((item, index) => (
                                                    <SwiperSlide key={index}>
                                                        <ProductBox 
                                                            minPrice={item.min_price} 
                                                            maxPrice={item.max_price} 
                                                            img={item.photo && item.photo.length > 0 ? item.photo[0].key : ""} 
                                                            name={item.name}
                                                            companyName={props.companyPage.name}
                                                            id={item.id}
                                                        />
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>
                                        ) : (
                                            // Carrusel vacío (Placeholders)
                                            <Swiper
                                                slidesPerView={3} spaceBetween={10} loop={false} navigation={true} className="mySwiper"
                                                breakpoints={{
                                                    344: { slidesPerView: 1, navigation: false },
                                                    768: { slidesPerView: 2, navigation: true },
                                                    1024: { slidesPerView: 3, navigation: true }
                                                }}
                                            >
                                                {props.owner === true ? (
                                                    <>
                                                        <SwiperSlide className="add-product-slide"><AddProductCard onAddProduct={toAddProduct}/></SwiperSlide>
                                                        <SwiperSlide className="empty-slide-placeholder"><PlaceholderProductBox /></SwiperSlide>
                                                        <SwiperSlide className="empty-slide-placeholder"><PlaceholderProductBox /></SwiperSlide>
                                                    </>
                                                ) : (
                                                    <>
                                                        <SwiperSlide className="empty-slide-placeholder"><PlaceholderProductBox /></SwiperSlide>
                                                        <SwiperSlide className="empty-slide-placeholder"><PlaceholderProductBox /></SwiperSlide>
                                                        <SwiperSlide className="empty-slide-placeholder"><PlaceholderProductBox /></SwiperSlide>
                                                    </>
                                                )}
                                            </Swiper>
                                        )}
                                    </div>
                                )}

                                {/* TABLA "Products" (Siempre visible)                       */}
                                <div className="products-table-section">
                                    
                                    {!isFreePlan && (
                                            <h4 style={{ 
                                                fontSize: '24px', 
                                                fontWeight: 'bold', 
                                                color: '#555', 
                                                marginBottom: '15px',
                                                marginTop: '10px'
                                            }}>
                                                Products
                                            </h4>
                                        )}

                                    <div style={{ maxWidth: '80%', minWidth: '320px' }}> 
                                        {tableData.length > 0 ? (
                                            // A. SI HAY DATOS: Mostrar la tabla
                                            <Table
                                                className="clean-product-table"
                                                style={{width: '100%'}} 
                                                columns={tableColumns}
                                                data={tableData}
                                                //stripe={true}
                                                emptyText="No products to display"
                                            />
                                        ) : (
                                            // B. NO HAY DATOS (Caso Legacy)
                                            props.owner === true ? (
                                                // B.1. Dueño: Mostrar aviso
                                                <div style={{ 
                                                    textAlign: 'center', 
                                                    padding: '20px', 
                                                    backgroundColor: '#f9fafc', 
                                                    borderRadius: '8px', 
                                                    border: '1px dashed #d9d9d9'
                                                }}>
                                                    <p style={{ color: '#99a9bf', marginBottom: '10px', fontSize: '0.9rem' }}>
                                                        Please update your profile to display your main products here.
                                                    </p>
                                                    <Button type="primary" size="small" onClick={handleUpdateProfile}>
                                                        Update Info
                                                    </Button>
                                                </div>
                                            ) : (
                                                // B.2. Visitante: Mostrar tabla vacía
                                                <Table
                                                    className="clean-product-table"
                                                    style={{width: '100%'}}
                                                    columns={tableColumns}
                                                    data={[]}
                                                    //stripe={true}
                                                    emptyText="No featured products listed yet."
                                                />
                                            )
                                        )}
                                    </div>
                                </div>

                            </div>
                                </Layout.Col>
                            </Layout.Row>
                            
                            
                            {    props.owner === true ?
                                    <Button className="btn-add-products" onClick={toAddProduct} type="primary">
                                        <i className="el-icon-plus"></i> {t('my-store.page.button-add-product')}
                                    </Button>
                                : <></>
                            }    
                                        
                                    
                        </Card>                    
                    </Layout.Col>
                </Layout.Row>

                <Layout.Row gutter="20">
                    <Layout.Col offset="1" span="20" xs={{ span: 23, offset: 1 }}>
                        <h3 className="company-page">
                            {t('my-store.page.who-are-we')}
                        </h3>
                    </Layout.Col>
                </Layout.Row>
                <Layout.Row gutter="22">
                <Layout.Col offset="1" span="22" xs={{ span: 24, offset: 0 }}>
                        <Card className="box-card card-whoarewe">
                        <div class="special-container">
                            {
                                    props.companyPage && props.companyPage.company_logo
                                    ?
                                        <S3Image
                                            className="special-container__image"
                                            imgKey={props.companyPage.company_logo.key}
                                            theme={{
                                                
                                            }}
                                            level="public"
                                        />
                                    :
                                        <img alt='img' className="special-container__image" src={aboutUsImg}/>
                            }
                            {props.owner === true 
                                                ?
                                                    <div className="company-title-img-btn2">
                                                            <div className="text-center">
                                                                <Button type="primary" onClick={()=> props.editCompanyImage('company_logo')}>
                                                                    {t('my-store.page.button-change-img')}
                                                                </Button>
                                                            </div>
                                                    </div>
                                                :
                                                    <></>
                            }
                        <div class="special-container__text">
                            <span className='description'>{props.companyPage? props.companyPage.description : ""}</span>
                        </div>
                        </div>
                                
                                {
/*
                                <Layout.Row type="flex" justify="center">
                                    <Layout.Col span="12">
                                        {
                                            props.companyPage.company_logo
                                            ?
                                                <S3Image
                                                    imgKey={props.companyPage.company_logo.key}
                                                    theme={{
                                                        photoImg: { maxWidth: "550px", maxHeight: "200px" }
                                                    }}
                                                    level="public"
                                                />
                                            :
                                                <div>IMG Default</div>
                                        }
                                        {props.owner === true 
                                                ?
                                                    <div className="company-title-img-btn2">
                                                            <div className="text-center">
                                                                <Button type="primary" onClick={()=> props.editCompanyImage('company_logo')}>
                                                                    {t('my-store.page.button-change-img')}
                                                                </Button>
                                                            </div>
                                                    </div>
                                                :
                                                    <></>
                                        }
                                    </Layout.Col>
                                    <Layout.Col span="12" >
                                            <Layout.Row type="flex">
                                                <Layout.Col>
                                                    &nbsp;
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex">
                                                <Layout.Col tag="cardPageTextSub">
                                                    <span className='description'> {props.owner === true ? <EditIcon handleClick={()=> props.editCompanyText('description')} width="25" height="25"/> : <></>} {props.companyPage.description}</span>
                                                </Layout.Col>
                                            </Layout.Row>
                                            <Layout.Row type="flex">
                                                <Layout.Col>
                                                    &nbsp;
                                                </Layout.Col>
                                            </Layout.Row>
                                            
                                    </Layout.Col>
                                </Layout.Row>
*/
                                }
                                
                        </Card>               
                    </Layout.Col>
                </Layout.Row>
                
                <Layout.Row type="flex" className="m-t-lg">
                    <Layout.Col span="24" offset="1" sm="20" lg="22" xs={{ span: 23, offset: 0 }}>
                        <Card className="box-card"
                            header={
                                <h3>
                                    {t('my-store.page.additional-info')}
                                </h3>
                            }
                        >
                            {/* --- Vista para Escritorio (Desktop) --- */}
                            {/* Esta versión se mostrará en pantallas grandes */}
                            <div className="additional-info-desktop">
                                <Layout.Row type="flex">
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        <p className="detail-sub-title">{t('my-store.page.business-type')}</p>
                                    </Layout.Col>
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        <p className="detail-sub-title">{t('my-store.page.member-since')}</p>
                                    </Layout.Col>
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        <p className="detail-sub-title">{t('my-store.page.year-stablished')}</p>
                                    </Layout.Col>
                                </Layout.Row>
                                <Layout.Row type="flex">
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        {props.companyPage.type}
                                    </Layout.Col>
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        {yearsFromToday(props.companyPage.createdAt)} years
                                    </Layout.Col>
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        {props.companyPage.age}
                                    </Layout.Col>
                                </Layout.Row>
                                <Layout.Row type="flex">
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        <p className="detail-sub-title">{t('my-store.page.city')}</p>
                                    </Layout.Col>
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        <p className="detail-sub-title">{t('my-store.page.annual-revenue')}</p>
                                    </Layout.Col>
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        <p className="detail-sub-title">{t('my-store.page.allow-custom-prd')}</p>
                                    </Layout.Col>
                                </Layout.Row>
                                <Layout.Row type="flex">
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        {displayCity}
                                    </Layout.Col>
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        {props.companyPage.anual_revenue}
                                    </Layout.Col>
                                    <Layout.Col span="24" offset="1" xs="20" sm="20" lg="8">
                                        {props.companyPage.allow_custom_product == 1 ? 'Yes' : 'No'}
                                    </Layout.Col>
                                    
                                </Layout.Row>
                            </div>

                            {/* --- Vista para Móvil --- */}
                            {/* Esta versión se mostrará en pantallas pequeñas */}
                            <div className="additional-info-movil">
                                {/* Fila 1: Business Type */}
                                <Layout.Row gutter={8} className="info-row-movil">
                                    <Layout.Col span={10} className="info-label-movil">{t('my-store.page.business-type')}:</Layout.Col>
                                    <Layout.Col span={14} className="info-value-movil">{props.companyPage.type}</Layout.Col>
                                </Layout.Row>
                                {/* Fila 2: Member Since */}
                                <Layout.Row gutter={8} className="info-row-movil">
                                    <Layout.Col span={10} className="info-label-movil">{t('my-store.page.member-since')}:</Layout.Col>
                                    <Layout.Col span={14} className="info-value-movil">{yearsFromToday(props.companyPage.createdAt)} years</Layout.Col>
                                </Layout.Row>
                                {/* Fila 3: Year Established */}
                                <Layout.Row gutter={8} className="info-row-movil">
                                    <Layout.Col span={10} className="info-label-movil">{t('my-store.page.year-stablished')}:</Layout.Col>
                                    <Layout.Col span={14} className="info-value-movil">{props.companyPage.age}</Layout.Col>
                                </Layout.Row>
                                {/* Fila 4: City */}
                                <Layout.Row gutter={8} className="info-row-movil">
                                    <Layout.Col span={10} className="info-label-movil">{t('my-store.page.city')}:</Layout.Col>
                                    <Layout.Col span={14} className="info-value-movil">{displayCity}</Layout.Col>
                                </Layout.Row>
                                {/* Fila 5: Annual Revenue */}
                                <Layout.Row gutter={8} className="info-row-movil">
                                    <Layout.Col span={10} className="info-label-movil">{t('my-store.page.annual-revenue')}:</Layout.Col>
                                    <Layout.Col span={14} className="info-value-movil">{props.companyPage.anual_revenue}</Layout.Col>
                                </Layout.Row>
                                {/* Fila 6: Allow Custom Product */}
                                <Layout.Row gutter={8} className="info-row-movil">
                                    <Layout.Col span={10} className="info-label-movil">{t('my-store.page.allow-custom-prd')}:</Layout.Col>
                                    <Layout.Col span={14} className="info-value-movil" >{props.companyPage.allow_custom_product == 1 ? 'Yes' : 'No'}</Layout.Col>
                                </Layout.Row>
                            </div>
                        </Card>
                    </Layout.Col>
                </Layout.Row>

                <Layout.Row type="flex" className="m-t-lg">
                    <Layout.Col span="24" offset="1" sm="20" lg="22" xs={{ span: 23, offset: 0 }}>
                    <Card className="box-card"
                    
                        header={
                            <h3 className="company-page">
                            {t('my-store.page.capacity')}
                            </h3>
                        }
                    >
                        {/* --- Vista para Escritorio (Layout Original) --- */}
                        <div className="capacity-desktop">
                            <Layout.Row type="flex" justify="center">
                                <Layout.Col span="7" >
                                        <Layout.Row type="flex" justify="center">
                                            <Layout.Col tag="cardPageText">
                                                {t('my-store.page.employees_qty')}
                                            </Layout.Col>
                                        </Layout.Row>
                                        <Layout.Row type="flex">
                                            <Layout.Col tag="cardPageTextSub">
                                                {props.companyPage.employees_qty}
                                            </Layout.Col>
                                        </Layout.Row>
                                </Layout.Col>
                                <Layout.Col span="7" >
                                        <Layout.Row type="flex" justify="center">
                                            <Layout.Col tag="cardPageText">
                                                {t('my-store.page.main-market')}
                                            </Layout.Col>
                                        </Layout.Row>
                                        <Layout.Row type="flex">
                                            <Layout.Col tag="cardPageTextSub">
                                                {props.companyPage.main_market}
                                            </Layout.Col>
                                        </Layout.Row>
                                </Layout.Col>
                                <Layout.Col span="7" >
                                        <Layout.Row type="flex" justify="center">
                                            <Layout.Col tag="cardPageText">
                                                {t('my-store.page.production_lines_qty')}
                                            </Layout.Col>
                                        </Layout.Row>
                                        <Layout.Row type="flex">
                                            <Layout.Col tag="cardPageTextSub">
                                                {props.companyPage.production_lines_qty}
                                            </Layout.Col>
                                        </Layout.Row>
                                </Layout.Col>
                            </Layout.Row>
                            <br/>
                            <Layout.Row type="flex" >
                                <Layout.Col tag="cardPageText" offset="1" span="7">
                                    {t('my-store.page.titles')}    
                                </Layout.Col>
                            </Layout.Row>
                            <Layout.Row type="flex" >
                                <Layout.Col offset="1" span="7">
                                    {props.companyPage.titles}
                                </Layout.Col>
                            </Layout.Row>
                            <Layout.Row type="flex" >
                                <Layout.Col offset="1" span="7">
                                    {props.companyPage.additional_titles1}
                                </Layout.Col>
                            </Layout.Row>
                            <Layout.Row type="flex" >
                                <Layout.Col offset="1" span="7">
                                    {props.companyPage.additional_titles2}
                                </Layout.Col>
                            </Layout.Row>
                            <Layout.Row type="flex" >
                                <Layout.Col offset="1" span="7">
                                    {props.companyPage.additional_titles3}
                                </Layout.Col>
                            </Layout.Row>
                            <Layout.Row type="flex" >
                                <Layout.Col offset="1" span="7">
                                    {props.companyPage.additional_titles4}
                                </Layout.Col>
                            </Layout.Row>
                        </div>
                        
                        {/* --- Vista para Móvil (Layout de 2 columnas por fila) --- */}
                        <div className="capacity-movil">
                            {/* Fila 1: Staff Number */}
                            <Layout.Row gutter={8} className="info-row-movil" align="top">
                                <Layout.Col span={10} className="info-label-movil">{t('my-store.page.employees_qty')}:</Layout.Col>
                                <Layout.Col span={14} className="info-value-movil">{props.companyPage.employees_qty}</Layout.Col>
                            </Layout.Row>
                            {/* Fila 2: Main Market */}
                            <Layout.Row gutter={8} className="info-row-movil" align="top">
                                <Layout.Col span={10} className="info-label-movil">{t('my-store.page.main-market')}:</Layout.Col>
                                <Layout.Col span={14} className="info-value-movil">{props.companyPage.main_market}</Layout.Col>
                            </Layout.Row>
                            {/* Fila 3: Production Lines */}
                            <Layout.Row gutter={8} className="info-row-movil" align="top">
                                <Layout.Col span={10} className="info-label-movil">{t('my-store.page.production_lines_qty')}:</Layout.Col>
                                <Layout.Col span={14} className="info-value-movil">{props.companyPage.production_lines_qty}</Layout.Col>
                            </Layout.Row>
                            {/* Fila 4: Product Certification (Principal) */}
                            {props.companyPage.titles && (
                                <Layout.Row gutter={8} className="info-row-movil" align="top">
                                    <Layout.Col span={10} className="info-label-movil">{t('my-store.page.titles')}:</Layout.Col>
                                    <Layout.Col span={14} className="info-value-movil">{props.companyPage.titles}</Layout.Col>
                                </Layout.Row>
                            )}
                            {/* Fila 5: Additional Titles */}
                            {props.companyPage.additional_titles1 && (
                                <Layout.Row gutter={8} className="info-row-movil" align="top">
                                    <Layout.Col span={10} className="info-label-movil">&nbsp;</Layout.Col>
                                    <Layout.Col span={14} className="info-value-movil">{props.companyPage.additional_titles1}</Layout.Col>
                                </Layout.Row>
                            )}
                            {/* ... Repite para additional_titles2, 3, 4 ... */}
                            {props.companyPage.additional_titles2 && (
                                <Layout.Row gutter={8} className="info-row-movil" align="top">
                                    <Layout.Col span={10} className="info-label-movil">&nbsp;</Layout.Col>
                                    <Layout.Col span={14} className="info-value-movil">{props.companyPage.additional_titles2}</Layout.Col>
                                </Layout.Row>
                            )}
                            {props.companyPage.additional_titles3 && (
                                <Layout.Row gutter={8} className="info-row-movil" align="top">
                                    <Layout.Col span={10} className="info-label-movil">&nbsp;</Layout.Col>
                                    <Layout.Col span={14} className="info-value-movil">{props.companyPage.additional_titles3}</Layout.Col>
                                </Layout.Row>
                            )}
                            {props.companyPage.additional_titles4 && (
                                <Layout.Row gutter={8} className="info-row-movil" align="top">
                                    <Layout.Col span={10} className="info-label-movil">&nbsp;</Layout.Col>
                                    <Layout.Col span={14} className="info-value-movil">{props.companyPage.additional_titles4}</Layout.Col>
                                </Layout.Row>
                            )}
                            
                        </div>

                    </Card>
                
                </Layout.Col>
            </Layout.Row>

            <Layout.Row type="flex" className="m-t-lg m-b-lg">
                <Layout.Col span="24" offset="1" xs="22" sm="20" lg="23">
                        <Layout.Row type="flex">
                            <Layout.Col span="24" xs="20" sm="20" lg="22">
                                <h3 className="company-page">{t('product.create.preview.contact-us')}</h3>
                            </Layout.Col>
                        </Layout.Row>
                        <Layout.Row type="flex">
                            <Layout.Col span="24" xs="22" sm="20" lg="21">
                                <p className="#">{t('product.create.preview.contact-us-inquiry')}</p>
                            </Layout.Col>
                        </Layout.Row>
                            
                        <Layout.Row type="flex">
                            <Layout.Col span="24" xs="24" sm="20" lg="23">
                                <Input
                                    type="textarea"
                                    value={props.questionInput}
                                    onChange={(v)=>{props.setQuestionInput != undefined ? props.setQuestionInput(v) : console.log(v)}}
                                    autosize={{ minRows: 8, maxRows: 8}}
                                />
                            </Layout.Col>
                        </Layout.Row>
                        <Layout.Row type="flex" >
                            <Layout.Col span="24" xs="20" sm="20" lg="21">
                                <Checkbox 
                                    checked={props.checkStatus} 
                                    onChange={(v)=>{props && props.setCheckStatus ? props.setCheckStatus(v) : console.log(v)}}
                                
                                >{t('product.create.preview.contact-us-permission')}</Checkbox>
                            </Layout.Col>
                        </Layout.Row>
                        <Layout.Row type="flex">
                            <Layout.Col span="24" xs="20" sm="20" lg="23">
                                <Layout.Row type="flex" justify="end">
                                    <Layout.Col tag="form-button">
                                    
                                        <Button onClick={props.handleChatInputMessage} type="primary">
                                                {t('product.create.preview.button-send')}
                                        </Button>
                                    
                                    </Layout.Col>
                                </Layout.Row>
                            </Layout.Col>
                        </Layout.Row>
                </Layout.Col>
            </Layout.Row>
                
        </div>
    )
}

export default MyPage;